import AdminTable from "../components/module/admin/AdminTable";
import AdminFilter from "../components/module/admin/AdminFilter";
import {SweetModal} from 'sweet-modal-vue'
import LpModal from '../components/module/common/LpModal.vue'
import Structure from '../helper/structure-booking'

export default {

  components: {
    AdminFilter,
    AdminTable,
    SweetModal,
    LpModal
  },

  created() {
    // tableData, filter_list 초기화
  },

  data() {
    return {
      tableData: [],
      filterData: [],
      filtered: {},
      filter_list: [],
      allCount: 0,
      filteredCount: 0,
      tableItems: [],
      structure_path:'',
      post_url:'',
      // 체크리스트
      checkArr: [],
      // 요청할 상태
      status: 0,
      // 변경할 상태값 목록
      status_arr: [],
      // 선택된 주문
      selectedItem: {
        title: '',
        name: '',
        status: 0,
        id: 0
      }
    }
  },
  watch: {
    modalStatus(n) {
      if(n==='close' && this.post_url){
        this.getData(this.post_url);
      }
    }
  },
  computed: {
  },

  methods: {
    // 체크박스 일괄 선택
    clickCheckBox(res) {
      if(res===true) {
        this.checkArr.forEach(item=> {
          item.value=true;
        })
      }
      else {
        this.checkArr.forEach(item=> {
          item.value=false;
        })
      }
    },
    // structre_path : 필터 데이터, 테이블 데이터
    // post_url : axios 호출할 post url
    initializing(structure_path, post_url, current_page) {
      this.structure_path = structure_path;
      this.post_url = post_url;
      this.setStructure(structure_path);
      this.initFiltered();
      this.getData();
      // this.getStatusList(current_page);
    },
    setStructure(structure_path) {
      // structure.js 에서 경로에 맞는 데이터를 온다.
      this.filterData = Structure[structure_path+'_filter_data'];
      this.tableData = Structure[structure_path+'_table_data'];

    },
    initFiltered() {
      this.filtered = {
        cur_page: 1,
        page_num:1,
        total_page:10,
        page_length: 10
      };
    },

    // 내역 가져오기
    getData() {
      if(!this.post_url) return;
      this.$axios.get(this.getUrl(this.post_url), {
        params: this.filtered
      })
        .then(res => {
          if ( res.status === 200 ) {
            if ( res.data.data === undefined )
              this.tableItems = res.data;
            else
              this.tableItems = res.data.data;

            // 무료체험 중 후기 작성 모달
            if(this.tableItems.length > 0
              && this.serviceInfo.plan && this.serviceInfo.plan.trial && !this.serviceInfo.plan.review) {
              this.$root.$emit('trialReviewModal');
            }

            this.filtered.page_length = res.data.page_length;
            this.filtered.cur_page = res.data.cur_page;
            this.filtered.total_page = res.data.total_page;
            this.allCount = res.data.total_count;
            this.filteredCount = res.data.count;

            // 주문번호 탭
            if(this.selectedTab===0) {
              let tableList = [];
              for(let i = 0; i < this.tableItems.length; i++) {
                tableList.push({id: this.tableItems[i].order_id, value: false });
              }
              this.checkArr = tableList;
            }
            // 상품 주문번호 탭
            else if(this.selectedTab===1) {
              // 체크리스트 추가
              let tableList = [];
              for (let i = 0; i < this.tableItems.length; i++) {
                tableList.push({id: this.tableItems[i].id, value: false});
              }
              this.checkArr = tableList;
            }

            /* 테이블에 재조합 rowspan 추가 */
            this.initDeliveryTable();
          }
        }).catch(res => {});
    },

    selPageLength(length) {
      this.filtered.page_length = length;
      this.filtered.page_num = 1;
      this.getData();
    },

    ordering(res){
      this.filtered.ordering=res;
      this.getData();
    },

    // 상세페이지
    clickDetail(id){
      this.$router.push(this.getPath(`booking/order/detail?id=${id}`));
    },

    // 상태값 목록
    getStatusList(current_page){
      //console.log('sdasda')
      this.$axios.get(this.getUrl(`booking/order/status?page=${current_page}`)).then(res=>{
        if(res.status === 200){
          this.status_arr = res.data;
        }
      })
    },

    // 결제 상태
    payStatus(status){
      if(status>=101) return '결제완료';
      else return '미결제'
    },

    // 주문 상태
    // convertStatusType(st){
    //   return Const['ko_purchase'][st]
    // },

    convertPayType(name){
      let value = '';
      switch(name) {
        case 'credit':
          value='신용카드';
          break;
        case 'phone':
          value='휴대폰';
          break;
        case 'vbank':
          value='무통장';
          break;
        case 'trans':
          value='실시간 계좌이체';
          break;
      }
      return value;
    },

    // 일괄 상태 변경
    clickChange(){
      // 취소요청, 취소완료시 모달 띄워서 확인하기
      if(this.status===900){
        this.cancelPurchase();
      }
      else if(this.status===901){
        this.cancelSuccess();
      }
      // 그 외 상태값 처리는 다이렉트로 진행
      else {
        let id_list = this.getCheckedArr();
        if(id_list.length===0) return;

        let url = '';
        if(this.selectedTab===0) url = 'booking/order/status/change/multiple';
        else if(this.selectedTab===1) url = 'booking/orderproduct/status/change/multiple';
        this.$axios.post(this.getUrl(url),{
          status: this.status,
          checked: id_list
        }).then(res=>{
          if(res.status===200){
            this.toast('처리가 완료되었습니다.');
            this.getData();
          }
        })
      }
    },

    openModal (item, status, title) {
      this.selectedItem.id = item.id;
      this.selectedItem.name = item.name;
      this.selectedItem.status = status;
      this.selectedItem.title = title;
      this.$modal.show('statusChangeModal');
    },

    // 단일 상태 변경
    statusChange() {
      let url = 'booking/order/status/change';
      this.$axios.post(this.getUrl(url), {
        id: this.selectedItem.id,
        status: this.selectedItem.status
      }).then(res=> {
        if(res.status===200) {
          this.toast('상태가 변경되었습니다.');
          this.$modal.hide('statusChangeModal');
          this.getData();
        }
      }).catch(error => {
        if (error.response) {
          if(error.response.data.message) {
            this.$modal.hide('orderStatusModal');
            this.toast(error.response.data.message);
          }
          else {
            this.$modal.hide('orderStatusModal');
            this.toast('서버에 오류가 발생했습니다. 관리자에게 문의주세요.');
          }
        }
        else {
          this.$modal.hide('orderStatusModal');
          this.toast('서버에 오류가 발생했습니다. 관리자에게 문의주세요.');
        }
      })
    },

    //  체크된 id들 가져오기
    getCheckedArr(){
      let id_list = [];
      for(let i=0; i<this.checkArr.length; i++){
        if(this.checkArr[i].value){
          id_list.push(this.checkArr[i].id);
        }
      }

      return id_list;
    },

    // 주문 취소
    cancelPurchase(){
      let id_list = this.getCheckedArr();
      if(id_list.length===0) return;
      this.$modal.show('cancelModal');
    },
  }
}
